const omit = (o, ...keys) => keys.reduce((memo, key) => {
	const {[key]: ignored, ...rest} = memo;
	return rest;
}, o);

export default omit;
